import { Injectable, Inject, Optional } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationExtras, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { of } from 'rxjs';
import { take, switchMap } from 'rxjs/operators';
import { PermissionsService } from '../services/permissions/permissions.service';
import { APP_SHORT_NAME } from '@pcplus/core';
import { AUTH_REDIRECT_PAGE, SUBSCRIPTIONS_PAGE } from '@pcplus/domain-core';
import { ALLOW_SELF_REGISTRATION } from '../tokens';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  constructor(
    private router: Router,
    private auth: AuthenticationService,
    private permissions: PermissionsService,
    @Inject(APP_SHORT_NAME) private appShortName: string,
    @Optional() @Inject(SUBSCRIPTIONS_PAGE) private subscriptionsPage: string,
    @Inject(AUTH_REDIRECT_PAGE) private authRedirectPage: string,
    @Inject(ALLOW_SELF_REGISTRATION) private allowSelfRegistration: boolean
  ) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(_route: ActivatedRouteSnapshot) {
    return this.auth.currentUser$.pipe(
      take(1),
      switchMap((cu) => {
        if (cu) {
          return of(true);
        }
        if (this.allowSelfRegistration) {
          const selectedSubscription = localStorage.getItem(
            this.appShortName + 'selectedSubscription'
          );

          if (selectedSubscription) {
            this.router.navigateByUrl('/register').then(
              () => {},
              (error) => {
                if (error) {
                  console.log(error);
                }
              }
            );
            return of(false);
          }
        }
        const navigationExtras: NavigationExtras = {
          queryParamsHandling: 'preserve',
          preserveFragment: true
        };
        // not logged in so redirect to login page
        this.router.navigate([this.authRedirectPage], navigationExtras).then(
          () => {},
          (error) => {
            if (error) {
              console.log(error);
            }
          }
        );
        return of(false);
      })
    );
  }
}
